import script from "./bonusomat-board-rules.vue?vue&type=script&setup=true&lang=ts"
export * from "./bonusomat-board-rules.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__